import React, {useEffect} from 'react';
import './App.scss';
import FooterComponent from "./components/FooterComponent";
import {Route, Routes} from "react-router-dom";
import PolicyPageRoute from "./routes/PolicyPageRoute";
import HomePageRoute from "./routes/HomePageRoute";

function App() {

    useEffect(() => {

        const script = document.createElement('script');

        script.src = "https://connect.facebook.net/fr_FR/sdk.js#xfbml=1&version=v12.0&appId=419616539559175&autoLogAppEvents=1";
        script.async = true;

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        }
    }, []);

  return (
    <div className="App">
        <div id="fb-root"></div>

        <Routes>
            <Route path="/" element={<HomePageRoute />} />
            <Route path="privacy-policy" element={<PolicyPageRoute />} />
        </Routes>

        <FooterComponent />
    </div>
  );
}

export default App;
